import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import MainContentLayout from '../../../components/MainContentLayout'
import { MoodsRouter } from '../../../utils/routes/MusicRoutes'

const menu: ItemType<MenuItemType>[] = [
  {
    label: 'All',
    key: 'all',
  },
  {
    label: 'New',
    key: 'new',
  },
]

export default function MoodsLayout() {
  return (
    <MainContentLayout
      navigationHeader={{
        headerMenu: menu,
        navigationPrefix: '/music/moods/',
      }}
    >
      <MoodsRouter />
    </MainContentLayout>
  )
}
